import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../base/input.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule],
    selector: 'wd-multiline-text',
    templateUrl: 'multiline-text-view.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/view-only.component.css'],
})
export class MultilineTextViewComponent extends InputComponent<string> {
	constructor() {
		super();
	}

	numberOfRows() {
		return this.model ? Math.max(1, this.model.split('\n').length) : 1;
	}
}
